import { useState } from "react";
import { Box } from "@mui/material";
import "./App.css";

import MainLayout from "./Components/Layout/MainLayout";
import {
  Header,
  Project,
  AboutUs,
  ContactUs,
  SideBar,
  CarouselBar,
  Explain,
} from "./Components/UI";
import ResponsiveDrawer from "./ResponsiveDrawer";

function App() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <MainLayout>
      <Box className="main">
        <Header></Header>
        <ResponsiveDrawer />
        <CarouselBar />
        <Explain />
        <SideBar value={value} handleChange={handleChange}></SideBar>
        <AboutUs value={value} handleChange={handleChange}></AboutUs>
        <Project></Project>
        <ContactUs></ContactUs>
      </Box>
    </MainLayout>
  );
}

export default App;
